module.exports = __webpack_public_path__ + "img/type--4-spans--multiple-lang--pt.c7c48bf6.jpg";